import { render, staticRenderFns } from "./ConsultationRequest.vue?vue&type=template&id=145e796b&"
import script from "./ConsultationRequest.vue?vue&type=script&lang=js&"
export * from "./ConsultationRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports